const config = {
    apiKey: process.env.REACT_APP_API_KEY,
    // API
    apiHost: process.env.REACT_APP_API_HOST,
    apiBase: process.env.REACT_APP_API_BASE,
}

export default config;